import {partition} from 'ramda';

import {Nullish} from 'shared/web';

import {Option} from '../types/VehicleCatalogueLogic';
import {
  CustomTenantMakeModelData,
  GroupType,
  TopMakesData,
  VehicleMakeDescriptor,
  VehicleMakeModelData,
  VehicleTypeEnumObject,
} from '../types/VehicleMakeModelParsers';

interface VehicleMakeParserProps {
  vehicleType: VehicleTypeEnumObject | Nullish;
  vehicleMakeData: VehicleMakeModelData | Nullish;
  customTenantMakeModelData: CustomTenantMakeModelData | Nullish;
  topMakesData: TopMakesData | Nullish;
  topMakesLabel: string;
  allMakesLabel: string;
  unknownMakes?: Option[];
}

export function vehicleMakeParser(props: VehicleMakeParserProps): VehicleMakeDescriptor {
  const unknownMakes = props.unknownMakes || [];

  const globalMakes =
    props.vehicleMakeData?.map<Option>((item) => ({
      label: item.default_label,
      value: item.make,
    })) || [];

  const tenantCustomMakeSlice = props.customTenantMakeModelData?.[props.vehicleType || '']?.makes;

  const customMakes = tenantCustomMakeSlice
    ? Object.entries(tenantCustomMakeSlice).reduce<Option[]>(
        (acc, [key, value]) => (value.isCustom ? [...acc, {label: key, value: key}] : acc),
        []
      )
    : [];

  const flatMakesOptions = [...globalMakes, ...customMakes];

  const [topMakesRaw, otherMakesRaw] = partition(
    (option) => props.topMakesData?.some((item) => item.code === option.value) || false,
    flatMakesOptions
  );

  const topMakes = topMakesRaw.sort((a, b) => a.label.localeCompare(b.label));
  const otherMakes = otherMakesRaw.sort((a, b) => a.label.localeCompare(b.label));

  const flatMakes = [...topMakes, ...otherMakes, ...unknownMakes];

  const groupedMakeOptions: GroupType[] = [
    {
      label: props.topMakesLabel,
      options: topMakes,
    },
    {
      label: props.allMakesLabel,
      options: [...otherMakes, ...unknownMakes],
    },
  ];

  return {
    groupedMakeOptions,
    detail: {
      globalMakes,
      customMakes,
      flatMakes,
    },
  };
}
